import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { class: "appFont" }
const _hoisted_4 = {
  key: 1,
  class: "text-center"
}
const _hoisted_5 = { class: "appFont" }
const _hoisted_6 = {
  key: 2,
  class: "text-center"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { class: "appFont" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PremiumBuy = _resolveComponent("PremiumBuy")!
  const _component_Answer = _resolveComponent("Answer")!
  const _component_AnswerButton = _resolveComponent("AnswerButton")!
  const _component_LinkButton = _resolveComponent("LinkButton")!
  const _component_Question = _resolveComponent("Question")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Error = _resolveComponent("Error")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["wrapper my-4 pt-16 pb-24 md:pb-5", {'pt-5':_ctx.singleQuestion}]),
    style: _normalizeStyle(_ctx.styles)
  }, [
    _createVNode(_component_PremiumBuy),
    _createElementVNode("main", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questions, (q) => {
        return (_openBlock(), _createBlock(_component_Question, {
          key: q.id,
          q: q
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(q.answer, (a, inx) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: a.id
              }, [
                (inx <= 2 || _ctx.singleQuestion)
                  ? (_openBlock(), _createBlock(_component_Answer, {
                      key: 0,
                      a: a
                    }, null, 8, ["a"]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128)),
            _createVNode(_component_AnswerButton),
            (q.answer_count > 3)
              ? (_openBlock(), _createBlock(_component_LinkButton, {
                  key: 0,
                  to: `/app/question/${q.id}`,
                  class: "block w-full transition duration-150 rounded-lg bg-gray-100 hover:bg-gray-200 dark:bg-gray-900 dark:hover:bg-gray-700 p-3 text-center cursor-pointer appFont"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('See more')), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["q"]))
      }), 128)),
      (_ctx.loadingMore || _ctx.questions.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_Spinner, { class: "fa-2x" }),
            _hoisted_2,
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('Just a moment')) + " ;)", 1)
          ]))
        : (_ctx.allLoaded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('Take a break, that\'s all for now')) + " :D", 1)
            ]))
          : _createCommentVNode("", true),
      (_ctx.failedMore)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_Error, { class: "fa-2x" }),
            _hoisted_7,
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('Failed to load more')) + " :(", 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 6))
}